// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { CustomEvent } from '@shared/utils/CustomEvents';
import TrioColorPickerTemplate from '@front/templates/TrioColorPickerTemplate.html';
import { ContainerControl } from './ContainerControl';
export class TrioColorPicker extends ContainerControl {
    constructor() {
        super();
    }
    oninit() {
        super.oninit();
        this.TrioColorChanged = new CustomEvent();
        this.observe('trioColor', this.onTrioColorChanged);
    }
    onTrioColorChanged(newTrioColor) {
        this.fire('onTrioColorChanged', newTrioColor);
        if (!isNullOrUndefined(this.TrioColorChanged)) {
            this.TrioColorChanged.Raise(this, newTrioColor);
        }
    }
}
ContainerControl.extendWith(TrioColorPicker, {
    data: function () {
        return {
            trioColor: null
        };
    },
    template: TrioColorPickerTemplate
});
